import { useContext } from 'react'

import RightsContext from './RightsContext'


const useRightsData = () => useContext(RightsContext)
export default useRightsData
